import React from 'react';
import BottomSheetContainer from '@app/sharedComponents/Bottomsheet/Bottomsheet'
import {ThemedText, ThemedView} from "@app/theme";
import Button from "@sharedComponents/Button/Button";
import SystemErrorIcon from "../../../../../assets/Icons/SystemErrorIcon";
import gs from "@app/styles/globalStyles";
import UserInfo from "../../../../../assets/Icons/UserInfo";

interface IndividualInfoCardProps {
    title: string;
    value: string;
    icon: React.ReactNode;
    showBorderPadding: boolean

}

export const IndividualInfoCard: React.FC<IndividualInfoCardProps> = ({
                                                                          title,
                                                                          value,
                                                                          icon,
                                                                          showBorderPadding = true
                                                                      }) => {
    return (
        <ThemedView>
            <ThemedView flexDirection={"row"} alignItems={"center"} style={{flexShrink: 1}}>
                <ThemedView width={40} height={40} alignItems={"center"}>
                    {icon}
                </ThemedView>
                <ThemedView ml={"lg"} style={{flexShrink: 1}}>
                    <ThemedText variant={"b4r"} color={"text-secondary"}>
                        {title}
                    </ThemedText>
                    <ThemedText variant={"b3m"} color={"text-primary"} mt={"xs"}>
                        {value}
                    </ThemedText>
                </ThemedView>
            </ThemedView>
            <ThemedView width={"100%"} borderWidth={1} borderColor={"border-secondary"} mt={"md"}
                        style={showBorderPadding && {
                            marginBottom: 16
                        }}/>

        </ThemedView>


    );
};